package com.appsyde.shared.presentation.screen.screen.inbox

import androidx.compose.runtime.Composable
import com.appsyde.shared.presentation.style.style.AppStylesInboxEmpty
import org.jetbrains.compose.web.css.Style
import org.jetbrains.compose.web.dom.*
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun InboxEmptyView(onTakeFirstTicket: () -> Unit) {
    Style(AppStylesInboxEmpty)
    Div(attrs = { classes(AppStylesInboxEmpty.emptyRoot) }) {
        Div(attrs = { classes(AppStylesInboxEmpty.iconWrap) }) {
            Text("📋")
        }
        H2(attrs = { classes(AppStylesInboxEmpty.title) }) {
            Text("Votre file est vide")
        }
        P(attrs = { classes(AppStylesInboxEmpty.subtitle) }) {
            Text("Vous n'avez encore aucun ticket en cours dans votre file de réponse. Parcourez les tickets ouverts et prenez en un pour commencer.")
        }
        Button(attrs = {
            classes(AppStylesInboxEmpty.primaryButton)
            attr("type", "button")
            onClick { onTakeFirstTicket() }
        }) {
            Text("Prendre un ticket")
        }
    }
}
